import React from 'react';

export default function Signup() {
  return (
    <form className="w-full">
      <div className="w-full flex flex-col justify-center items-center font-matter md:flex-row">
        <input
          type="email"
          placeholder="Enter your mail"
          className="text-base md:text-lg outline-none py-5 md:py-7 px-5 md:px-7 w-full md:w-[359px] rounded md:rounded-tl md:rounded-bl md:rounded-none"
          style={{
            // boxShadow: `rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px`,
            boxShadow: "0px 0px 40px rgba(16, 97, 139, 0.11)"
          }}
        />
        <button className="rounded mt-4 md:rounded-tr md:m-0 md:rounded-br md:rounded-none font-semibold bg-cstm-green max-w-[182px] text-[#fff] text-base md:text-lg py-5 md:py-7 w-full md:w-[40%] px-4 md:px-8 hover:shadow-xl">
          Sign me up
        </button>
      </div>
    </form>
  );
}
